import React, { useMemo } from 'react'
import { useState } from 'react'
import { Block, CRRender, Image, Inline } from '@/components/crRender'
import placeholderImg from '@/assets/images/Not_available.jpg'
import { FileUploadField } from '../../shared'
import { useTranslation } from 'react-i18next'
import ActionBtn from '@/components/ActionBtn'
import './style.css'
import { translate } from '@/utils/langUtils'

import Img  from "@/assets/images/placeholders/pdf.png"

const FileDocRow = ({ docInfo, updateTechnology }) => {

    const [isEditImg, setIsEditImg] = useState(false)
    const { t } = useTranslation()

    const showDoc = useMemo(() => {
        let file = window.API_URL + docInfo?.data[docInfo?.data?.length - 1]?.name
        if (file.includes('.pdf')) {
            return {
                link: Img,
                isPdf: true,
                fileLink: file
            }
        } else {
            return {
                link: file,
                isPdf: false
            }
        }
    }, [docInfo])


    const handleOpenImgPopup = (link) => {
        window.open(link, '_blank')
    }
    return (
        <div className="technology-item-card col-lg-4 col-md-6 col-sm-12 mb-2" >
            <div className="technology-item-card-content">
                <div >
                    <Inline className="doc-name" isRender={!!docInfo?.name}>
                        {t(docInfo?.name)}
                    </Inline>
                    <Block isRender={!isEditImg} className="row relative-container">
                        <CRRender isRender={showDoc.isPdf}>
                                <Image className="pointer" placeholder={placeholderImg} src={showDoc.link}  onClick={() => handleOpenImgPopup(showDoc.fileLink)}/>
                        </CRRender>
                        <CRRender isRender={!showDoc.isPdf}>
                            <Image className="pointer" placeholder={placeholderImg} src={showDoc.link} />
                        </CRRender>
                        <ActionBtn
                            icon="carbon:close-filled"
                            className="remove-tech-btn remove-tech-image-btn pointer"
                            onApply={() => setIsEditImg(true)} />
                    </Block>
                    <Block isRender={!!isEditImg}>
                        <FileUploadField
                            className="col-lg-12"
                            formHandler={(name, value) => updateTechnology(docInfo?.name, name, value)}
                            name="picture"
                            id={`technology-picture-${docInfo?.name}`}
                            accept="image/*, application/pdf"
                            maxFiles={1}
                            value={docInfo?.picture || ''}
                        />
                    </Block>
                </div>
            </div>
        </div >
    )
}

export default FileDocRow